import { render } from "./next.vue?vue&type=template&id=2b0f4c89"
import script from "./next.vue?vue&type=script&lang=js"
export * from "./next.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__